import { render } from "./OrdemProducaoModal.vue?vue&type=template&id=b4eefddc&ts=true"
import script from "./OrdemProducaoModal.vue?vue&type=script&lang=ts"
export * from "./OrdemProducaoModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__